<template>
  <div class="medical-record-container">
    <van-nav-bar title="基本信息" left-arrow @click-left="goBack" class="page-title"/>

    <el-form
      :model="form"
      :rules="rules"
      ref="formRef"
      :label-width="isMobile ? '100%' : '100px'"
      :label-position="isMobile ? 'top' : 'right'"
      class="medical-form"
    >
      <!-- 学生身份证号码 -->
      <el-form-item label="身份证号" prop="idCard" required>
        <el-input 
          v-model="form.idCard"
          placeholder="请输入学生身份证号"
          type="text"
          maxlength="18"
          show-word-limit
          @input="handleIdCardInput"
        ></el-input>
      </el-form-item>

      <!-- 学生姓名 -->
      <el-form-item label="学生姓名:" prop="studentname">
        <el-input
          v-model="form.studentname"
          placeholder="请输入学生姓名"
          clearable
        />
      </el-form-item>

      <!-- 性别（设为不可更改） -->
      <el-form-item label="性别:" prop="gender">
        <el-radio-group 
          v-model="form.gender" 
          class="gender-radio-group"
          :disabled="true" 
        >
          <el-radio label="男">男</el-radio>
          <el-radio label="女">女</el-radio>
        </el-radio-group>
      </el-form-item>

      <!-- 地址 -->
      <el-form-item label="现居地址:" prop="countyAddress">
        <el-input
          v-model="form.countyAddress"
          type="textarea"
          :rows="4"
          placeholder="请输入现居地址"
        />
      </el-form-item>

      <!-- 家长姓名 -->
      <el-form-item label="家长姓名:" prop="parentname">
        <el-input
          v-model="form.parentname"
          placeholder="请输入家长姓名"
          clearable
        />
      </el-form-item>

      <!-- 与学生关系 -->
      <el-form-item label="亲属关系:" prop="relation">
        <el-select 
          v-model="form.relation"
          placeholder="请选择与学生的关系"
          class="school-select"
        >
          <el-option label="父亲" value="父亲"></el-option>
          <el-option label="母亲" value="母亲"></el-option>
          <el-option label="兄弟姐妹" value="兄弟姐妹"></el-option>
          <el-option label="其他" value="其他"></el-option>
        </el-select>
      </el-form-item>

      <!-- 家长联系电话 -->
      <el-form-item label="联系电话" prop="parentPhone" required>
        <el-input 
          v-model="form.parentPhone"
          placeholder="请输入家长联系电话"
          type="text"
          maxlength="11"
          show-word-limit
        ></el-input>
      </el-form-item>

      <!-- 就读学校（下拉选项从接口获取） -->
      <el-form-item label="就读学校:" prop="school">
        <el-select 
          v-model="form.school"
          placeholder="请选择"
          class="school-select"
          :disabled="!schoolList.length"
        >
          <el-option 
            v-for="(item, index) in schoolList" 
            :key="index" 
            :label="item.schName" 
            :value="item.schName"
          ></el-option>
        </el-select>
      </el-form-item>

      <!-- 提示信息 -->
      <el-form-item class="tips-item">
        <div class="tips-box">
          <span class="tips-icon">ℹ️</span>
          <p class="tips-content">
            <strong>就读学校提示：</strong><br />
            仅支持兴隆街道范围内学校线上开具复课证明，如未找到孩子学校，请线下办理或咨询校医前往对应基层医疗机构开具证明。
          </p>
        </div>
      </el-form-item>

      <!-- 年级 -->
      <el-form-item label="年级:" prop="grade">
        <el-input
          v-model="form.grade"
          placeholder="请输入年级（如：1年级）"
          clearable
        />
      </el-form-item>

      <!-- 班级 -->
      <el-form-item label="班级:" prop="class">
        <el-input
          v-model="form.class"
          placeholder="请输入班级（如：1班）"
          clearable
        />
      </el-form-item>

      <!-- 提交按钮 -->
      <el-form-item class="action-buttons">
        <el-button type="primary" @click="handleSave" class="save-button" :loading="submissionLoading">保存</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import request from '@/utils/request';
import { Toast } from 'vant';

export default {
  name: 'Xinxi',
  data() {
    const validateIdCard = (rule, value, callback) => {
      if (!value) {
        callback(new Error('请输入身份证号'));
      } else {
        const reg = /(^\d{15}$)|(^\d{17}(\d|X|x)$)/;
        if (reg.test(value)) {
          callback();
        } else {
          callback(new Error('请输入合法的身份证号'));
        }
      }
    };

    const validateGrade = (rule, value, callback) => {
      if (!value) {
        callback(new Error('请输入年级'));
      } else {
        const reg = /^\d+年级$/;
        if (reg.test(value)) {
          callback();
        } else {
          callback(new Error('年级格式不正确，请输入如：1年级'));
        }
      }
    };

    const validateClass = (rule, value, callback) => {
      if (!value) {
        callback(new Error('请输入班级'));
      } else {
        const reg = /^\d+班$/;
        if (reg.test(value)) {
          callback();
        } else {
          callback(new Error('班级格式不正确，请输入如：1班'));
        }
      }
    };

    const validatePhone = (rule, value, callback) => {
      if (!value) {
        callback(new Error('请输入联系电话'));
      } else {
        const reg = /^1[3-9]\d{9}$/;
        if (reg.test(value)) {
          callback();
        } else {
          callback(new Error('请输入合法的11位手机号'));
        }
      }
    };

    return {
      form: {
        idCard: '',
        studentname: '',
        gender: '',
        countyAddress: '',
        parentname: '',
        relation: '',
        parentPhone: '',
        school: '',
        grade: '',
        class: ''
      },
      rules: {
        idCard: [
          { required: true, message: '请输入学生身份证号', trigger: 'blur' },
          { validator: validateIdCard, trigger: 'blur' }
        ],
        studentname: [
          { required: true, message: '请输入学生姓名', trigger: 'blur' },
          { min: 2, max: 10, message: '姓名长度为2-10位', trigger: 'blur' },
          { pattern: /^[\u4e00-\u9fa5a-zA-Z]+$/, message: '姓名仅支持中文和英文', trigger: 'blur' }
        ],
        gender: [{ required: true, message: '性别由身份证号自动识别或从缓存读取', trigger: 'change' }],
        countyAddress: [{ required: true, message: '请输入现居地址', trigger: 'blur' }],
        parentname: [
          { required: true, message: '请输入家长姓名', trigger: 'blur' },
          { min: 2, max: 10, message: '姓名长度为2-10位', trigger: 'blur' },
          { pattern: /^[\u4e00-\u9fa5a-zA-Z]+$/, message: '姓名仅支持中文和英文', trigger: 'blur' }
        ],
        relation: [{ required: true, message: '请选择与学生的关系', trigger: 'change' }],
        parentPhone: [
          { required: true, message: '请输入家长联系电话', trigger: 'blur' },
          { validator: validatePhone, trigger: 'blur' }
        ],
        school: [{ required: true, message: '请选择就读学校', trigger: 'change' }],
        grade: [
          { required: true, message: '请输入年级', trigger: 'blur' },
          { validator: validateGrade, trigger: 'blur' }
        ],
        class: [
          { required: true, message: '请输入班级', trigger: 'blur' },
          { validator: validateClass, trigger: 'blur' }
        ]
      },
      submissionLoading: false,
      queId: '',
      userInfo: null,
      schoolList: []
    };
  },
  computed: {
    isMobile() {
      return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    }
  },
  async created() {
    this.loadUserData();
    await this.getSchoolList();
    window.addEventListener('storage', this.handleStorageChange);
  },
  beforeDestroy() {
    window.removeEventListener('storage', this.handleStorageChange);
  },
  activated() {
    this.loadUserData();
  },
  methods: {
    goBack() {
      this.$router.go(-1);
    },

    handleStorageChange(e) {
      if (e.key === 'userInfo' || e.key === 'apiResponseData') {
        console.log(`检测到 ${e.key} 缓存更新，重新加载表单数据`);
        // 延迟执行，确保缓存数据已完全更新
        setTimeout(() => this.loadUserData(), 100);
      }
    },

    async getSchoolList() {
      try {
        const response = await request({
          url: '/api/schoolInfos/all',
          method: 'get'
        });

        if (response.code === 200 && Array.isArray(response.data)) {
          this.schoolList = response.data.filter(item => item.schName);
          console.log('学校列表获取成功：', this.schoolList);
        } else {
          throw new Error('接口返回格式异常');
        }
      } catch (error) {
        console.error('获取学校列表失败：', error);
        Toast({ message: '获取学校列表失败，请稍后重试', type: 'error', duration: 3000 });
        this.schoolList = [];
      }
    },

    loadUserData() {
      const userInfoStr = localStorage.getItem('userInfo');
      const apiResponseStr = localStorage.getItem('apiResponseData');
      let apiResponseData = {};

      // 解析接口响应数据（优先使用接口返回数据）
      if (apiResponseStr) {
        try {
          apiResponseData = JSON.parse(apiResponseStr);
          console.log('从 apiResponseData 读取到接口返回数据：', apiResponseData);
        } catch (e) {
          console.error('解析 apiResponseData 失败:', e);
          localStorage.removeItem('apiResponseData');
          apiResponseData = {};
        }
      }

      // 解析用户信息（从localStorage读取）
      if (userInfoStr) {
        try {
          this.userInfo = JSON.parse(userInfoStr);
          this.queId = this.userInfo.queId || '';

          // 核心修改1：完整回显所有字段，优先接口数据，其次缓存数据，最后为空
          this.form.idCard = apiResponseData.queChildrenSfz || this.userInfo.queChildrenSfz || '';
          this.form.studentname = apiResponseData.queChildrenName || this.userInfo.queChildrenName || '';
          this.form.gender = apiResponseData.queChildrenGender || this.userInfo.queChildrenGender || ''; // 回显性别
          this.form.countyAddress = apiResponseData.queChildrenAddress || this.userInfo.queChildrenAddress || '';
          this.form.parentname = apiResponseData.queParentName || this.userInfo.queParentName || '';
          this.form.relation = apiResponseData.queChildrenRelationship || this.userInfo.queChildrenRelationship || '';
          this.form.parentPhone = apiResponseData.quePhone || this.userInfo.quePhone || '';
          this.form.school = apiResponseData.queChildrenSchool || this.userInfo.queChildrenSchool || '';
          this.form.grade = apiResponseData.queChildrenGrade || this.userInfo.queChildrenGrade || '';
          this.form.class = apiResponseData.queChildrenClass || this.userInfo.queChildrenClass || '';

          // 核心修改2：优化性别识别逻辑：如果缓存中已有性别，无需重复识别；无性别时再通过身份证识别
          if (this.form.idCard && !this.form.gender) {
            this.handleIdCardInput();
          } else if (this.form.gender) {
            console.log('从缓存读取到性别：', this.form.gender);
          }

          console.log('表单数据回显完成（优先接口返回数据）:', this.form);
        } catch (e) {
          console.error('解析userInfo失败:', e);
          this.$message.warning('加载用户信息失败，请重新登录');
          localStorage.removeItem('userInfo');
          this.$router.push('/');
        }
      } else {
        this.$message.warning('未检测到登录信息，请先登录');
        this.$router.push('/');
      }
    },

    handleIdCardInput() {
      const idCard = this.form.idCard.trim();
      if (!idCard) {
        this.form.gender = '';
        return;
      }

      // 优化18位身份证号性别识别（兼容X结尾）
      if (idCard.length === 18) {
        const genderCode = idCard.charAt(16);
        if (!isNaN(genderCode)) {
          this.form.gender = parseInt(genderCode) % 2 === 1 ? '男' : '女';
        } else if (genderCode.toUpperCase() === 'X') {
          this.form.gender = '女'; // 行业默认X按女性处理，可根据需求调整
        } else {
          this.form.gender = '';
          this.$message.warning('身份证号格式异常，无法识别性别');
        }
      } 
      // 优化15位身份证号性别识别
      else if (idCard.length === 15) {
        const genderCode = idCard.charAt(14);
        if (!isNaN(genderCode)) {
          this.form.gender = parseInt(genderCode) % 2 === 1 ? '男' : '女';
        } else {
          this.form.gender = '';
          this.$message.warning('身份证号格式异常，无法识别性别');
        }
      } 
      // 身份证号长度不合法
      else {
        this.form.gender = '';
        this.$message.warning('请输入15位或18位有效身份证号');
      }
    },

    handleSave() {
      this.$refs.formRef.validate(valid => {
        if (valid) {
          this.submissionLoading = true;
          if (!this.userInfo) {
            this.$message.error('用户信息缺失，无法保存');
            this.submissionLoading = false;
            return;
          }

          // 构建更新后的用户信息（确保所有字段同步到缓存）
          const updatedUserInfo = {
            ...this.userInfo,
            queId: this.queId,
            queChildrenSfz: this.form.idCard,
            queChildrenName: this.form.studentname,
            queChildrenGender: this.form.gender,
            queParentName: this.form.parentname,
            quePhone: this.form.parentPhone,
            queChildrenAddress: this.form.countyAddress,
            queChildrenRelationship: this.form.relation,
            queChildrenSchool: this.form.school,
            queChildrenGrade: this.form.grade,
            queChildrenClass: this.form.class
          };

          try {
            // 保存到localStorage，确保其他页面能读取到最新数据
            localStorage.setItem('userInfo', JSON.stringify(updatedUserInfo));
            this.userInfo = updatedUserInfo;

            localStorage.setItem('xinxiCompleted', 'true');

            this.$message.success('基本信息保存成功！');
            setTimeout(() => {
              this.$router.push('/survey');
            }, 1500);
          } catch (e) {
            console.error('保存userInfo失败:', e);
            this.$message.error('数据保存失败，请重试');
          } finally {
            this.submissionLoading = false;
          }
        } else {
          this.$message.error('请填写完整所有必填项，并检查格式是否正确');
          return false;
        }
      });
    },

    handleReset() {
      this.$refs.formRef.resetFields();
    }
  }
};
</script>

<style scoped>
.medical-record-container {
  padding: 16px;
  background-color: #f9f9f9;
  min-height: 100vh;
  box-sizing: border-box;
}

.page-title {
  font-size: 20px;
  color: #333;
  margin-bottom: 20px;
  padding-bottom: 10px;
  border-bottom: 1px solid #e9e9e9;
  text-align: center;
}

.medical-form {
  background-color: #fff;
  padding: 20px;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
}

.el-form-item {
  margin-bottom: 20px;
}

:deep(.tips-item .el-form-item__content) {
  margin-left: 0 !important;
}
.tips-box {
  background-color: #f5fafe;
  border-left: 4px solid #409eff;
  padding: 15px;
  border-radius: 4px;
  margin-bottom: 10px;
}
.tips-icon {
  color: #409eff;
  font-weight: bold;
  margin-right: 8px;
}
.tips-content {
  color: #666;
  line-height: 1.6;
  margin: 0;
  font-size: 14px;
}

.action-buttons {
  margin-top: 30px;
  display: flex;
  justify-content: center;
  gap: 15px;
}

.save-button {
  min-width: 120px;
}

@media (max-width: 768px) {
  .medical-form {
    padding: 15px;
  }

  :deep(.el-form-item) {
    margin-bottom: 25px;
  }
  
  :deep(.el-input),
  :deep(.el-select),
  :deep(.el-radio-group) {
    width: 100% !important;
  }

  .gender-radio-group {
    display: flex;
    justify-content: space-around;
    align-items: center;
  }
  
  .action-buttons {
    flex-direction: column;
    align-items: stretch;
    gap: 10px;
  }
  
  .save-button {
    width: 100%;
    min-width: auto;
  }
}
</style>